import { Send } from "lucide-react";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@/components/ui/molecules/InputGroup";
import type { KeyboardEvent, Ref } from "react";

interface ChatInputBarProps {
  value: string;
  disabled?: boolean;
  onChange: (nextValue: string) => void;
  onSubmit: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  inputRef?: Ref<HTMLInputElement>;
}

export function ChatInputBar({
  value,
  disabled = false,
  onChange,
  onSubmit,
  onFocus,
  onBlur,
  inputRef,
}: ChatInputBarProps) {
  const onInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="border-t border-dark-invirtus-soft px-3 py-2.5">
      <InputGroup size="md">
        <InputGroupInput
          ref={inputRef}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={onInputKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          placeholder="Write message"
          rounded="full"
        />
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            type="icon"
            intent="primary"
            icon={<Send />}
            aria-label="Send message"
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={onSubmit}
            disabled={disabled || !value.trim()}
            className="!text-purple hover:!bg-purple/15 focus:!ring-purple/30"
          />
        </InputGroupAddon>
      </InputGroup>
    </div>
  );
}